import { render } from "./LinkAccountMask.vue?vue&type=template&id=154930d6"
import script from "./LinkAccountMask.vue?vue&type=script&lang=js"
export * from "./LinkAccountMask.vue?vue&type=script&lang=js"

import "./LinkAccountMask.vue?vue&type=style&index=0&id=154930d6&lang=scss"
import "./LinkAccountMask.vue?vue&type=style&index=1&id=154930d6&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__